export default __webpack_public_path__ + "static/media/12843-7933-SASA-Swift-Launch-Brochure-v5-1-66.16a6f300.pdf";